/**
 * Per-client overrides for aGM pages (proof-of-concept deployments).
 *
 * Kept in one place so a POC can be wound down by deleting its entry; clients without an
 * entry get the standard behaviour everywhere.
 */
const AGM_CLIENT_OVERRIDES = {
    c110: {
        /* Graph Report V2 opens on the window the POC graph was built over. */
        graphReportDefaultDates: { start: '2026-09-20', end: '2026-10-26' },
        /* The POC graph is the mesh (deterministic) graph only. */
        graphReportDataSources: ['deterministic-graph'],
        /* No cluster-formation data is produced for the POC. */
        hideClusterFormation: true,
        /* Graph Report V2 tabs shown only when their report returns rows; the POC graph often
           has no diff or expiry history yet. */
        graphReportTabsHiddenWhenEmpty: ['Graph Diff', 'Expired Entities', 'Expired Edges'],
    },
};

/**
 * @param {string} cid
 * @returns {Object|null} the overrides for `cid`, or null when it has none
 */
export function getAgmClientOverrides(cid) {
    return (cid && AGM_CLIENT_OVERRIDES[cid]) || null;
}
